const config = {
  API_BASE_URL: "/api",
  ORIGIN: ["localhost", "0.0.0.0", "127.0.0.1"].indexOf(window.location.hostname) === -1 ?
    `https://${window.location.hostname.split(".")[0]}.alertrules.com`
    :
    `https://${process.env.REACT_APP_API_SUBDOMAIN}.alertrules.com`,
};

export default config;